import React, { useEffect, useState } from "react";
import config from "../../../config/config.js";
import business from "../../../services/business.js";
import InputForm from "../../Form/InputForm.js";
import Loading from "../../Loading.js";
import tools from "../../../lib/tools.js";
import { toast as alert } from "react-toastify";
import { Checkbox } from "@mui/material";

const parseQuestionValue = (value) => {
  if (value === 1 || value === "1") return 1;
  if (value === 0 || value === "0") return 0;
  if (value === 2 || value === "2") return 2;
  return "";
};

const buildParecerState = (form) => ({
  texto: form?.texto_parecer || "",
  aprovacao: form?.aprovacao_parecer || form?.aprovacao || "",
  so_questao1: parseQuestionValue(form?.so_questao1),
  so_questao1_obs: form?.so_questao1_obs || "",
  so_questao2: parseQuestionValue(form?.so_questao2),
  so_questao2_obs: form?.so_questao2_obs || "",
  so_questao3: parseQuestionValue(form?.so_questao3),
  so_questao3_obs: form?.so_questao3_obs || "",
  so_questao4: parseQuestionValue(form?.so_questao4),
  so_questao4_obs: form?.so_questao4_obs || "",
  so_questao5: parseQuestionValue(form?.so_questao5),
  so_questao5_obs: form?.so_questao5_obs || "",
});

const perguntasSegundaOpiniao = [
  {
    key: "so_questao1",
    obsKey: "so_questao1_obs",
    titulo: "1 - Os procedimentos solicitados possuem cobertura no Rol da ANS?",
    primeiraOpcao: { label: "Sim", value: 1 },
    segundaOpcao: { label: "Não - Quais?", value: 0 },
    exibirObsQuando: 0,
    obsLabel: "Quais?",
  },
  {
    key: "so_questao2",
    obsKey: "so_questao2_obs",
    titulo: "2 - Os procedimentos solicitados possuem DUT da ANS?",
    primeiraOpcao: { label: "Não", value: 0 },
    segundaOpcao: { label: "Sim - Quais procedimentos?", value: 1 },
    exibirObsQuando: 1,
    obsLabel: "Quais procedimentos?",
  },
  {
    key: "so_questao3",
    obsKey: "so_questao3_obs",
    titulo: "3 - O beneficiário atende os critérios da DUT?",
    primeiraOpcao: { label: "Sim", value: 1 },
    segundaOpcao: { label: "Não - Cite os critérios que o beneficiário não se enquadra?", value: 0 },
    terceiraOpcao: { label: "Não se aplica", value: 2 },
    exibirObsQuando: 0,
    obsLabel: "Cite os critérios que o beneficiário não se enquadra",
  },
  {
    key: "so_questao4",
    obsKey: "so_questao4_obs",
    titulo: "4 - Os materiais e/ou medicamentos são off-label ou experimental?",
    primeiraOpcao: { label: "Não", value: 0 },
    segundaOpcao: { label: "Sim - Quais?", value: 1 },
    exibirObsQuando: 1,
    obsLabel: "Quais?",
  },
  {
    key: "so_questao5",
    obsKey: "so_questao5_obs",
    titulo: "5 - Há outras alternativas terapêuticas disponíveis?",
    primeiraOpcao: { label: "Não", value: 0 },
    segundaOpcao: { label: "Sim - Quais?", value: 1 },
    exibirObsQuando: 1,
    obsLabel: "Quais?",
  },
];

export default function Parecer({ form, setForm }) {
  const [loading, setLoading] = useState(false);
  const [parecer, setParecer] = useState(() => buildParecerState(form));
  const [historico, setHistorico] = useState({
    texto: form?.texto_historico_beneficiario || "",
  });
  const [declaracaoChecada, setDeclaracaoChecada] = useState(false);

  useEffect(() => {
    setParecer(buildParecerState(form));
    setHistorico({
      texto: form?.texto_historico_beneficiario || "",
    });
  }, [form]);

  const podeVisualizarParecer =
    config.isOperadora() ||
    [4, 8, 9].includes(parseInt(config.user.tipo)) ||
    (config.isEnfermeira() && form.id_processo_etapa !== "10") ||
    (form.id_processo_etapa !== "3" &&
      form.responsaveis.id_desempatador === config.user.id);

  const podeEditarParecer =
    (form.id_processo_etapa === "3" &&
      form.responsaveis.id_desempatador === config.user.id) ||
    (config.isEnfermeira() && form.id_processo_etapa === "10") ||
    config.isAdmin();

  const atualizarParecer = (campo, valor) => {
    setParecer((prev) => ({
      ...prev,
      [campo]: valor,
    }));
  };

  const setModel = (name, value) => {
    atualizarParecer("texto", value);
  };

  const setModel2 = (name, value) => {
    setHistorico({ ...historico, texto: value });
  };

  const selecionarResposta = (campo, valor, obsCampo, exibirObsQuando) => {
    setParecer((prev) => ({
      ...prev,
      [campo]: valor,
      [obsCampo]: valor === exibirObsQuando ? prev[obsCampo] : "",
    }));
  };

  const perguntasObrigatoriasPreenchidas = () => {
    if (form?.id_processo_tipo !== "1") {
      return true;
    }

    const perguntas = [
      { key: "so_questao1", obsKey: "so_questao1_obs", exibirObsQuando: 0 },
      { key: "so_questao2", obsKey: "so_questao2_obs", exibirObsQuando: 1 },
      { key: "so_questao3", obsKey: "so_questao3_obs", exibirObsQuando: 0 },
      { key: "so_questao4", obsKey: "so_questao4_obs", exibirObsQuando: 1 },
      { key: "so_questao5", obsKey: "so_questao5_obs", exibirObsQuando: 1 },
    ];

    return perguntas.every((pergunta) => {
      const resposta = parecer?.[pergunta.key];

      if (resposta !== 0 && resposta !== 1 && resposta !== 2) {
        return false;
      }

      if (resposta === pergunta.exibirObsQuando) {
        return Boolean((parecer?.[pergunta.obsKey] || "").trim());
      }

      return true;
    });
  };

  const enviarParecer = async () => {
    if (!form) {
      return false;
    }

    setLoading(true);

    let data = {
      id_processo: form?.id,
      id_desempatador: form?.responsaveis.id_desempatador,
      id_enfermeira: form?.responsaveis.id_enfermeira,
      texto: parecer.texto,
      historico: historico.texto,
      aprovacao: 0,
      tipo_processo: form?.id_processo_tipo,
    };

    if (form?.id_processo_tipo === "1") {
      data = {
        ...data,
        so_questao1: parecer.so_questao1 === "" ? null : parecer.so_questao1,
        so_questao1_obs: parecer.so_questao1_obs || "",
        so_questao2: parecer.so_questao2 === "" ? null : parecer.so_questao2,
        so_questao2_obs: parecer.so_questao2_obs || "",
        so_questao3: parecer.so_questao3 === "" ? null : parecer.so_questao3,
        so_questao3_obs: parecer.so_questao3_obs || "",
        so_questao4: parecer.so_questao4 === "" ? null : parecer.so_questao4,
        so_questao4_obs: parecer.so_questao4_obs || "",
        so_questao5: parecer.so_questao5 === "" ? null : parecer.so_questao5,
        so_questao5_obs: parecer.so_questao5_obs || "",
      };
    }

    if (!form || !data.texto) {
      alert.error("Você precisa informar suas considerações.");
      setLoading(false);
      return false;
    }

    if (form?.id_processo_tipo === "1" && !perguntasObrigatoriasPreenchidas()) {
      alert.error("Responda todas as perguntas obrigatórias antes de avançar.");
      setLoading(false);
      return false;
    }

    form.id_parecer
      ? await business.addParecer(data, form.id_parecer)
      : await business.addParecer(data);

    setForm("texto_parecer", parecer?.texto || "");
    setForm("texto_historico_beneficiario", historico?.texto || "");

    if (form?.id_processo_tipo === "1") {
      setForm("so_questao1", parecer.so_questao1 === "" ? null : parecer.so_questao1);
      setForm("so_questao1_obs", parecer.so_questao1_obs || "");
      setForm("so_questao2", parecer.so_questao2 === "" ? null : parecer.so_questao2);
      setForm("so_questao2_obs", parecer.so_questao2_obs || "");
      setForm("so_questao3", parecer.so_questao3 === "" ? null : parecer.so_questao3);
      setForm("so_questao3_obs", parecer.so_questao3_obs || "");
      setForm("so_questao4", parecer.so_questao4 === "" ? null : parecer.so_questao4);
      setForm("so_questao4_obs", parecer.so_questao4_obs || "");
      setForm("so_questao5", parecer.so_questao5 === "" ? null : parecer.so_questao5);
      setForm("so_questao5_obs", parecer.so_questao5_obs || "");
    }

    setLoading(false);
    setDeclaracaoChecada(false);
    alert.success("As informações foram salvas");
  };

  const renderPergunta = (pergunta, disabled = false) => {
    const resposta = parecer?.[pergunta.key];
    const mostrarObservacao = resposta === pergunta.exibirObsQuando;

    return (
      <div key={pergunta.key} className="mt-30 mb-30">
        <p className="f600-16 mb-10">{pergunta.titulo}</p>

        <div className="flex ai-fs mb-10">
          <Checkbox
            checked={resposta === pergunta.primeiraOpcao.value}
            onChange={() =>
              selecionarResposta(
                pergunta.key,
                pergunta.primeiraOpcao.value,
                pergunta.obsKey,
                pergunta.exibirObsQuando
              )
            }
            disabled={disabled}
          />
          <p className="mt-10">{pergunta.primeiraOpcao.label}</p>
        </div>

        <div className="flex ai-fs mb-10">
          <Checkbox
            checked={resposta === pergunta.segundaOpcao.value}
            onChange={() =>
              selecionarResposta(
                pergunta.key,
                pergunta.segundaOpcao.value,
                pergunta.obsKey,
                pergunta.exibirObsQuando
              )
            }
            disabled={disabled}
          />
          <p className="mt-10">{pergunta.segundaOpcao.label}</p>
        </div>

        {pergunta.terceiraOpcao && <div className="flex ai-fs mb-10">
          <Checkbox
            checked={resposta === pergunta.terceiraOpcao.value}
            onChange={() =>
              selecionarResposta(
                pergunta.key,
                pergunta.terceiraOpcao.value,
                pergunta.obsKey,
                pergunta.exibirObsQuando
              )
            }
            disabled={disabled}
          />
          <p className="mt-10">{pergunta.terceiraOpcao.label}</p>
        </div>}

        {mostrarObservacao && (
          <InputForm
            className="mt-10 mb-10"
            label={pergunta.obsLabel}
            name={pergunta.obsKey}
            placeholder={pergunta.obsLabel}
            type="text"
            maxLength={255}
            value={parecer?.[pergunta.obsKey] || ""}
            model={(name, value) => atualizarParecer(pergunta.obsKey, value)}
            disabled={disabled}
          />
        )}
      </div>
    );
  };

  return (
    <div className="overflow-y scrollfit h-100 aba-parecer">
      {[12, 42].includes(parseInt(form.id_processo_etapa_status)) ? (
        <div className="ml-20 mb-20">
          {form?.id_processo_tipo === "3" && (
            <button
              className="btn btn-primary f700-16 jc-sb"
              onClick={(e) => {
                e.preventDefault();
                tools.openUrlExternal(`/${form.id}/consenso`);
              }}
              disabled={
                form?.id_processo_etapa !== "4" &&
                form?.id_processo_etapa !== "10" &&
                form?.id_processo_etapa !== "11"
              }
            >
              Consenso Técnico <i className="icon icon-print rotate-180 i-20 ml-10" />
            </button>
          )}
        </div>
      ) : (
        <div>
          <h1 className="f600-18 ml-30 mt-20 mb-40">Parecer</h1>
          {loading ? (
            <div className="mh-30 grid col-3 w-100">
              <Loading />
            </div>
          ) : (
            <div className="mh-30">
              {form?.id_processo_tipo === "1" && (
                <button
                  className="btn btn-primary f700-16 jc-sb"
                  onClick={(e) => {
                    e.preventDefault();
                    tools.openUrlExternal(`/${form.id}/parecer-segunda-opiniao`);
                  }}
                  disabled={
                    (form?.id_processo_etapa !== "4" &&
                    form?.id_processo_etapa !== "10") || !form?.id_parecer
                  }
                >
                  Parecer conclusivo <i className="icon icon-print rotate-180 i-20 ml-10" />
                </button>
              )}

              {form?.id_processo_tipo === "3" && (
                <button
                  className="btn btn-primary f700-16 jc-sb"
                  onClick={(e) => {
                    e.preventDefault();
                    tools.openUrlExternal(`/${form.id}/parecer`);
                  }}
                  disabled={
                    (form?.id_processo_etapa !== "4" &&
                    form?.id_processo_etapa !== "10" &&
                    form?.id_processo_etapa !== "11" &&
                    form?.id_processo_etapa !== "316" &&
                    form?.id_processo_etapa !== "317") || !form?.id_parecer
                  }
                >
                  Parecer conclusivo <i className="icon icon-print rotate-180 i-20 ml-10" />
                </button>
              )}

              {form.id_processo_tipo === "1" && (
                <div>
                  {podeVisualizarParecer && (
                    <InputForm
                      className="mt-50 mb-40 vertical-resize tiebreaker-required"
                      label="Histórico do beneficiário:"
                      type="textarea"
                      height="200px"
                      value={historico?.texto}
                      disabled
                    />
                  )}

                  {podeEditarParecer && (
                    <InputForm
                      className="mt-50 mb-40 vertical-resize tiebreaker-required"
                      label="Histórico do beneficiário:"
                      name="historico"
                      placeholder="Descrever a história clínica do(a) beneficiário(a), descrevendo o sexo, a idade e a conclusão dos exames encaminhados."
                      type="textarea"
                      height="200px"
                      model={setModel2}
                      value={historico?.texto}
                    />
                  )}
                </div>
              )}

              {podeVisualizarParecer && (
                <InputForm
                  className="mt-50 mb-40 vertical-resize tiebreaker-required"
                  label={`${form.id_processo_tipo === "1"
                    ? "Conclusão:"
                    : "Parecer do desempatador:"
                    }`}
                  type="textarea"
                  height="450px"
                  model={setModel}
                  value={parecer?.texto}
                  disabled
                />
              )}

              {podeEditarParecer && (
                <>
                  <InputForm
                    className="mt-50 mb-20 vertical-resize tiebreaker-required"
                    label={`${form.id_processo_tipo === "1"
                      ? "Conclusão:"
                      : "Parecer do desempatador:"
                      }`}
                    name="parecer"
                    placeholder={`${form.id_processo_tipo === "1"
                      ? "Descrever a conclusão da sua análise e quando necessário indicar outros tipos de tratamento, seja cirúrgico ou conservador. Citar as referências utilizadas em seu parecer."
                      : "Descrever a história clínica do(a) beneficiário(a), descrevendo o sexo, a idade e a conclusão dos exames encaminhados. Caso não tenha citado as referências utilizadas nas justificativas acima, citar neste campo."
                      }`}
                    type="textarea"
                    height="300px"
                    model={setModel}
                    value={parecer?.texto}
                    maxLength={20000}
                  />
                  <p className="fn-14 text-end">({parecer?.texto?.length || 0} / 20000)</p>
                </>
              )}

              {(form?.id_processo_tipo === "1" && podeEditarParecer) && (
                <div className="mt-30">
                  {perguntasSegundaOpiniao.map((pergunta) =>
                    renderPergunta(pergunta, !podeEditarParecer)
                  )}
                </div>
              )}

              <div className="flex mb-20">
                <Checkbox onChange={() => setDeclaracaoChecada(!declaracaoChecada)} />
                <p>
                  Declaro que realizei a presente análise em conformidade com as
                  diretrizes de fundamentação científica, não utilizando recursos
                  de inteligência artificial, assumindo integral responsabilidade
                  pela autoria e pela veracidade das informações contidas neste
                  parecer técnico.
                </p>
              </div>

              <p>
                {form.processo_conclusao && (
                  <span>RESULTADO: {form.processo_conclusao}</span>
                )}
              </p>
              <p>
                {form.responsaveis.nome_desempatador
                  ? "Dr(a). " + form.responsaveis.nome_desempatador
                  : ""}
              </p>

              <div className="flex gap-25 mt-40">
                {parecer.aprovacao === "1" && (
                  <div className="status flex ai-fc gap-20 positivo active">
                    <div className="progress-status">
                      <div className="pie-cicle">
                        <i className="icon icon-check i-20" />
                      </div>
                    </div>
                    <div className="flex fd-fc f400-16">
                      Confirmado
                      <span className="f400-12">
                        O parecer foi confirmado, avançar no processo.
                      </span>
                    </div>
                  </div>
                )}

                {parecer.aprovacao === "2" && (
                  <div className="status flex ai-fc gap-20 negativo active">
                    <div className="progress-status">
                      <div className="pie-cicle">
                        <i className="icon icon-cross-small i-25" />
                      </div>
                    </div>
                    <div className="flex fd-fc f400-16">
                      Não aceito
                      <span className="f400-12">
                        O parecer foi devolvido para ajustes.
                      </span>
                    </div>
                  </div>
                )}
              </div>

              <div className="flex jc-fe">
                {config.temPermissao("processo:parecer:cadastrar") &&
                  ((form.responsaveis.id_desempatador === config.user.id &&
                    form.id_processo_etapa === "3") ||
                    (((form.responsaveis.id_enfermeira === config.user.id) ||
                      (form.responsaveis.id_enfermeira_validacao === config.user.id)) &&
                      form.id_processo_etapa === "10") ||
                    (config.isAdmin() && form.id_processo_etapa !== "4")) && (
                    <button
                      className="btn btn-primary f700-16"
                      onClick={() => enviarParecer()}
                      disabled={
                        !declaracaoChecada ||
                        (form?.id_processo_tipo === "1" && !perguntasObrigatoriasPreenchidas())
                      }
                    >
                      Salvar
                    </button>
                  )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
